import React, { useContext, useEffect, useState, useRef } from 'react'
import {
    Card,
    CardBody,
    CardTitle,
    Container,
    Row,
    Col,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
    Input,
    Button,
    FormGroup,
    Label,
    Table
} from 'reactstrap'

import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'

import { withRouter, Link } from 'react-router-dom'
import Select from "react-select"
import { GeneralContext } from '../../context/'
import ApiService from '../../data/services/ApiService'
import { isEmpty, head, filter, debounce } from 'lodash'
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
import DefaultImage from '../../assets/images/avatar-product-placeholder.png'
import CurrencyFormat from 'react-currency-format'
import { connect } from "react-redux"
import { getProductImageUrl, getVariantImageUrl } from '../../helpers/ProductMedia'

const ORDER_STATUS = {
    HEALTHY: 'healthy',
    WARNING: 'warning',
    DANGER: 'danger',
}

const Index = (props) => {
    const generalContext = useContext(GeneralContext)
    const { setLoading, setBreadcrumb } = generalContext
    const [branchId, setBranchId] = useState()
    const [folio, setFolio] = useState(0)
    const [dueDate] = useState(new Date((new Date()).getTime() + (10 * 86400000))) // 10 days @note: this rule is not currently used
    const [notes, setNotes] = useState('')
    const [customerId, setCustomerId] = useState()
    const [lineItems, setLineItems] = useState([])
    const [customers, setCustomers] = useState([])
    const [branches, setBranches] = useState([])
    const [popularProducts, setPopularProducts] = useState([])
    const [filteredProducts, setFilteredProducts] = useState([])
    const [branchBudget, setBranchBudget] = useState(0)
    const [currentSpent, setCurrentSpent] = useState(0)
    const [orderStatus, setOrderStatus] = useState(ORDER_STATUS.HEALTHY)
    const [isOrderBlocked, setIsOrderBlocked] = useState(false)
    const [cartTotal, setCartTotal] = useState(0)

    useEffect(() => {
        setCartTotal(lineItems.reduce((a, b) => a + +b.total, 0))
    }, [lineItems]) // eslint-disable-line

    const getDisabledReason = () => {
        if (!lineItems || lineItems.length === 0) return "Agrega productos al carrito"
        if (branchBudget === undefined || currentSpent === undefined) return "Datos de presupuesto no disponibles"
        if (branchBudget && branchBudget !== 0 && cartTotal > (branchBudget - currentSpent)) return "Este pedido excede el presupuesto disponible"

        return null
    }

    const disabledReason = getDisabledReason()

    const debouncedSearch = useRef(
        debounce(async (criteria) => {
            _searchVariants(criteria)
        }, 300)
    ).current

    const _searchVariants = async (criteria) => {
        try {
            setLoading(true)
            const response = await ApiService.searchVariants(criteria)
            setFilteredProducts(response.data.products)
        } catch (error) {
            // catch error
            toastr.error(`No pude buscar productos`, `Oop's!`)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        if (!lineItems || lineItems.length === 0) {
            setOrderStatus(ORDER_STATUS.DANGER)
            setIsOrderBlocked(true)

            return
        }

        if (!branchBudget || branchBudget === 0) {
            setOrderStatus(ORDER_STATUS.HEALTHY)
            setIsOrderBlocked(false)
        } else {
            const budgetLeft = branchBudget - currentSpent
            const bufferThreshold = branchBudget * 0.2

            if (cartTotal > budgetLeft) {
                setOrderStatus(ORDER_STATUS.DANGER)
                setIsOrderBlocked(true)
            } else if (cartTotal >= (budgetLeft - bufferThreshold)) {
                setOrderStatus(ORDER_STATUS.WARNING)
                setIsOrderBlocked(false)
            } else {
                setOrderStatus(ORDER_STATUS.HEALTHY)
                setIsOrderBlocked(false)
            }
        }
    }, [lineItems, cartTotal, branchBudget, currentSpent])

    useEffect(() => {
        const { profile } = props
        if (profile && profile.customer) {
            const customerValue = {
                value: profile.customer.id,
                label: profile.customer.businessName
            }

            setCustomerId(customerValue)
        }

        if (profile && profile.branch) {
            const branchValue = {
                value: profile.branch.id,
                label: profile.branch.branchName
            }

            setBranchId(branchValue)
            fetchBudgetInfo(branchValue)
        }
    }, [props, fetchBudgetInfo])

    useEffect(() => {
        if (!branchId) return

        fetchBudgetInfo(branchId)
    }, [branchId, fetchBudgetInfo])

    async function fetchBudgetInfo(branchId) {
        try {
            setLoading(true)

            const resp = await ApiService.getBranchById(branchId.value)
            setBranchBudget(resp.data.branch.monthlyBudget || 0)

            const resp2 = await ApiService.getBranchSpend(branchId.value)
            setCurrentSpent(resp2.data.spent || 0)
        } catch (err) {
            toastr.error('Error fetching branch budget/spent')
        } finally {
            setLoading(false)
        }
    }

    async function fetchCustomers() {
        try {
            setLoading(true)
            const response = await ApiService.getCustomers()
            let customers = []

            response.data.customers.map((item) => {
                return customers.push({
                    value: item.id,
                    label: item.businessName
                })
            })

            setLoading(false)
            setCustomers(customers)
        } catch (error) {
            toastr.error(`I couldn't fetch your customers`)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        setBreadcrumb({
            icon: '',
            parent: `Pedidos`,
            parentLink: '/sales-order',
            item: `Pedido #P-${folio}`
        })
    }, [folio]) // eslint-disable-line

    useEffect(() => {
        (async () => {
            if (!customerId) {
                return
            }

            await fetchBranchesByCustomerId(customerId.value)
        })()
    }, [customerId, fetchBranchesByCustomerId])

    useEffect(() => {
        (async () => {
            await fetchNextFolio()
            await fetchCustomers()
            await fetchPopularProducts()
        })()
    }, []) // eslint-disable-line

    useEffect(() => {
        (() => {
            debouncedSearch.cancel()
        })()
    }, [debouncedSearch]) // eslint-disable-line

    async function fetchBranchesByCustomerId(customerId) {
        try {
            setLoading(true)
            const response = await ApiService.getBranchesByCustomerId(customerId)
            let branches = []

            response.data.branches.map((b) => {
                return branches.push({
                    value: b.id,
                    label: b.branchName,
                })
            })

            setLoading(false)
            setBranches(branches)
        } catch (error) {
            toastr.error(`No pude extraer las sucursales`)
        } finally {
            setLoading(false)
        }
    }

    const __findAndAddProduct = async (criteria) => {
        try {
            setLoading(true)
            const response = await ApiService.searchVariants(criteria)
            if (response.data.products.length === 1) {
                const product = response.data.products[0]

                __addItemToCart(product)

                document.getElementById("searchInput").value = ''
                setFilteredProducts(response.data.products)
            }
        } catch (error) {
            // catch error
        } finally {
            setLoading(false)
        }
    }

    const _filterProducts = async (value) => {
        if (value === '') {
            setFilteredProducts(popularProducts)

            return
        }

        try {
            setLoading(true)
            debouncedSearch(value)
        } catch (error) {
            // catch error
            toastr.error(`No pude buscar productos`, `Oop's!`)
        } finally {
            setLoading(false)
        }
    }

    const addItemToCart = async (data) => {
        try {
            setLoading(true)

            let itemFound = false
            const updatedItems = [...lineItems].map(item => {
                if (item.product && item.product.id === data.product.id) {
                    itemFound = true
                    const quantity = +item.quantity + +data.quantity
                    return {
                        ...item,
                        quantity,
                        total: quantity * item.unitPrice,
                        unitPrice: +item.unitPrice,
                        branchId
                    }
                }

                return item
            })

            if (!itemFound) {
                updatedItems.push(data)
            }

            setLineItems(updatedItems)
        } finally {
            setLoading(false)
        }
    }

    const _renderProductAvatar = (variant) => {
        let product = variant.product

        if (variant && !isEmpty(variant.image)) {
            return (
                <img
                    alt={``}
                    style={{ maxWidth: '64px' }}
                    src={getVariantImageUrl(variant, product, DefaultImage)}
                />
            )
        }

        if (isEmpty(product.images)) {
            return (
                <img alt={``} style={{ maxWidth: '64px' }} src={DefaultImage} />
            )
        }

        const image = filter(product.images, { featured: true })

        if (isEmpty(head(image))) {
            return (
                <img
                    alt={``}
                    style={{ maxWidth: '64px' }}
                    src={getProductImageUrl(head(product.images), product, DefaultImage)}
                />
            )
        }

        return (
            <div style={{ textAlign: 'center' }}>
                <img
                    style={{ maxWidth: '64px' }}
                    alt={head(image).id}
                    src={getProductImageUrl(head(image), product, DefaultImage)}
                />
            </div>
        )
    }

    const removeItemFromCart = async (item) => {
        const newItems = lineItems.filter(i => i.product.id !== item.product.id)
        setLineItems(newItems)
    }

    async function fetchNextFolio() {
        try {
            setLoading(true)
            const response = await ApiService.getNextSalesOrderFolio()

            setFolio(response.data.folio)
        } catch (error) {

        } finally {
            setLoading(false)
        }
    }

    async function _createOrder() {
        try {
            if (!validateForm()) {
                toastr.info(`no te olvides llegar los campos`)

                return false
            }

            setLoading(true)
            const total = lineItems.reduce((a, b) => a + +b.total, 0)
            const response = await ApiService.saveSalesOrder({
                branchId: branchId.value,
                customerId: customerId.value,
                folio,
                dueDate,
                notes,
                total,
                lineItems,
                channel: 'Insumos UI'
            })

            if (response.data.code === 'E_MISSING_FIELDS') {
                toastr.error(`No olvides llenar los campos`)

                return
            }

            if (response.data.code !== 'ORDER_CREATED') {
                toastr.error(`No pude generar el pedido, por favor intenta de nuevo`)

                return
            }

            const w = window.open(`/sales-order/print/${response.data.order.id}`, `Pedido`, "width=900,height=960,menubar=0,status=0,scrollbars=1,resizable=1")
            if (!w) {
                toastr.info(`No pude abrir el comprobante de pedido`)
            }

            props.history.push(`/sales-order/view/${response.data.order.id}`)
        } catch (error) {
            if (error.response && error.response.data && error.response.data.code === 'MINIMUM_ORDER_AMOUNT') {
                toastr.error(error.response.data.message)
            } else {
                toastr.error(`No pude generar el pedido`)
            }
        } finally {
            setLoading(false)
        }
    }

    const validateForm = () => {
        if (lineItems.length < 1) { return false }
        if (branchId === undefined) { return false }

        return true
    }

    const __addItemToCart = (product, quantity = 1) => {
        if (branchBudget && branchBudget !== 0 && (cartTotal + (product.unitPrice * quantity)) > (branchBudget - currentSpent)) {
            toastr.error(`No puedes agregar este producto, el total del carrito supera el presupuesto disponible de la sucursal.`)

            return
        }

        addItemToCart({
            product,
            quantity,
            branchId,
            itemsFulfilled: 0,
            unitCost: product.unitCost,
            unitPrice: product.unitPrice,
            total: +product.unitPrice * +quantity
        })
    }

    async function fetchPopularProducts() {
        try {
            setLoading(true)
            const response = await ApiService.getPopularProducts()

            setFilteredProducts(response.data.products)
            setPopularProducts(response.data.products)
        } catch (error) {
            // catch error
            toastr.error(`I couldn't fetch your products`, `Oop's!`)
        } finally {
            setLoading(false)
        }
    }

    // const __reloadForm = async () => {
    //     setDueDate(new Date((new Date()).getTime() + (10 * 86400000)))
    //     setEmail('')
    //     setNotes('')
    //     setCustomerId()
    //     setCurrencyId()
    //     setLineItems([])
    //     setCurrencyRate(0.00)
    //     setRequireShipping(false)
    //     setRequiredShippingDate(new Date((new Date()).getTime() + (5 * 86400000)))
    //     setShippingCosts()

    //     await fetchNextFolio()
    // }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Row>
                        <Col sm={12} md={12} lg={12}>
                            <Card>
                                <Row>
                                    <Col style={{ textAlign: 'right' }} sm={12} md={12} lg={12}>
                                        <CardTitle>
                                            {isOrderBlocked ? (
                                                <OverlayTrigger
                                                    placement="top"
                                                    overlay={<Tooltip>{disabledReason}</Tooltip>}
                                                >
                                                    <span className="d-inline-block">
                                                        <Button
                                                            color='primary'
                                                            className={`order-status-${orderStatus}`}
                                                            disabled
                                                            style={{ pointerEvents: 'none' }}
                                                        >
                                                            Crear Pedido
                                                        </Button>
                                                    </span>
                                                </OverlayTrigger>
                                            ) : (
                                                <Button
                                                    color='primary'
                                                    className={`order-status-${orderStatus}`}
                                                    onClick={(e) => {
                                                        e.preventDefault()
                                                        _createOrder()
                                                    }}
                                                >
                                                    Crear Pedido
                                                </Button>
                                            )}
                                        </CardTitle>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                    </Row>

                    <Row>
                        <Col sm={12} md={12} lg={3}>
                            <Card>
                                <Row>
                                    {props.profile.role.codeName === 'ADMIN' && (
                                        <>
                                            <Col md={12} sm={12}>
                                                <FormGroup>
                                                    <Label>Cliente que recibe</Label>

                                                    <Select
                                                        value={customerId}
                                                        defaultValue={customerId}
                                                        placeholder="Clientes..."
                                                        onChange={(value) => {
                                                            setCustomerId(value)
                                                        }}
                                                        options={customers}
                                                        classNamePrefix="select2-selection"
                                                    />
                                                </FormGroup>
                                            </Col>

                                            <Col md={12} sm={12}>
                                                <FormGroup>
                                                    <Label>Sucursal que recibe</Label>

                                                    <Select
                                                        value={branchId}
                                                        defaultValue={branchId}
                                                        placeholder="Sucursales..."
                                                        onChange={(value) => {
                                                            setBranchId(value)
                                                        }}
                                                        options={branches}
                                                        classNamePrefix="select2-selection"
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </>
                                    )}

                                    <Col md={12} sm={12}>
                                        <FormGroup>
                                            <Label>Notas</Label>

                                            <Input
                                                type="textarea"
                                                name="notes"
                                                value={notes}
                                                placeholder=""
                                                onChange={e => setNotes(e.target.value)}
                                                style={{
                                                    height: '100px',
                                                    minHeight: '100px',
                                                    lineHeight: '1.5',
                                                    resize: 'vertical',
                                                    overflow: 'auto',
                                                }}
                                                className="custom-textarea"
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12} sm={12}>
                                        <div style={{ marginTop: '1rem' }}>
                                            <strong>Presupuesto mensual:</strong>{' '}
                                            <CurrencyFormat
                                                decimalScale={2}
                                                displayType="text"
                                                thousandSeparator
                                                prefix="$"
                                                value={branchBudget}
                                            />

                                            <br />

                                            <strong>Presupuesto utilizado:</strong>{' '}
                                            <CurrencyFormat
                                                decimalScale={2}
                                                displayType="text"
                                                thousandSeparator
                                                prefix="$"
                                                value={currentSpent}
                                            />

                                            <br />

                                            <strong>Total actual del carrito:</strong>{' '}
                                            <CurrencyFormat
                                                decimalScale={2}
                                                displayType="text"
                                                thousandSeparator
                                                prefix="$"
                                                value={lineItems.reduce((a, b) => a + +b.total, 0)}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>

                        <Col sm={12} md={12} lg={9}>
                            <Card>
                                <CardBody>
                                    {/* Product Search */}
                                    <Row>
                                        <Col sm={12}>
                                            <InputGroup>
                                                <InputGroupAddon addonType="prepend">
                                                    <InputGroupText>
                                                        <i className="fa fa-barcode" aria-hidden="true" /> / <i className="fa fa-search" aria-hidden="true" />
                                                    </InputGroupText>
                                                </InputGroupAddon>

                                                <Input
                                                    autoFocus={true}
                                                    id="searchInput"
                                                    type={`search`}
                                                    className="form-control"
                                                    style={{ zIndex: '0' }}
                                                    placeholder="buscar productos o códigos de barras"
                                                    onKeyUp={(e) => _filterProducts(e.target.value)}
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Tab') {
                                                            e.preventDefault()
                                                            __findAndAddProduct(e.target.value)
                                                        }
                                                    }}
                                                />
                                            </InputGroup>
                                        </Col>
                                    </Row>

                                    <div className='product-grid' style={{ paddingTop: '24px' }}>
                                        {filteredProducts.map((product, i) => {
                                            return (
                                                <div className='product' key={i} xs={12} sm={4} md={3} lg={3}>
                                                    <a style={{ color: '#464b56' }} href="/pos" onClick={(e) => {
                                                        e.preventDefault()

                                                        __addItemToCart(product)

                                                        document.getElementById("searchInput").focus()
                                                    }}>
                                                        <figure className='product-photo'>{_renderProductAvatar(product)}</figure>
                                                        <span className='product-name'>{product.name}</span> <br />
                                                        <span className='product-price'>
                                                            Precio Unitario: <CurrencyFormat decimalScale={2} displayType="text" thousandSeparator prefix="$" value={(+product.unitPrice)} />
                                                        </span>
                                                    </a>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </CardBody>
                            </Card>

                            {lineItems.length > 0 && (
                                <Card>
                                    <div className="table-responsive">
                                        <Table responsive="true">
                                            <thead>
                                                <tr>
                                                    <th>Producto</th>
                                                    <th>CANT</th>
                                                    <th>Precio Unitario</th>
                                                    <th>Importe</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {lineItems.map((item, i) => (
                                                    <tr key={i}>
                                                        <td>
                                                            <Link to="#" onClick={() => removeItemFromCart(item)}>
                                                                <i className="mdi mdi-close"></i>
                                                            </Link>
                                                            <strong>{item.product.name}</strong> <em>{item.product.sku}</em><br />
                                                        </td>
                                                        <td>
                                                            <Input
                                                                type="number"
                                                                value={item.quantity}
                                                                onChange={(e) => {
                                                                    const { value } = e.target;
                                                                    let total = +value * +item.unitPrice;
                                                                    const items = [...lineItems];

                                                                    if (branchBudget && branchBudget !== 0 && (branchBudget - currentSpent) < total) {
                                                                        toastr.error(`No puedes agregar este producto, el total del carrito supera el presupuesto disponible de la sucursal.`);
                                                                        return;
                                                                    }

                                                                    items[i] = {
                                                                        ...items[i],
                                                                        quantity: value,
                                                                        total
                                                                    };

                                                                    setLineItems(items);
                                                                }}
                                                            />
                                                        </td>
                                                        <td>
                                                            <CurrencyFormat
                                                                decimalScale={2}
                                                                displayType="text"
                                                                thousandSeparator
                                                                prefix="$"
                                                                value={+item.unitPrice}
                                                            />
                                                        </td>
                                                        <td>
                                                            <CurrencyFormat
                                                                decimalScale={2}
                                                                displayType="text"
                                                                thousandSeparator
                                                                prefix="$"
                                                                value={+item.unitPrice * +item.quantity}
                                                            />
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <td colSpan={3} style={{ textAlign: 'right' }}>
                                                        Total:
                                                    </td>
                                                    <td>
                                                        <CurrencyFormat
                                                            decimalScale={2}
                                                            displayType="text"
                                                            thousandSeparator
                                                            prefix="$"
                                                            value={lineItems.reduce((a, b) => a + +b.total, 0)}
                                                        />
                                                    </td>
                                                </tr>
                                            </tfoot>
                                        </Table>
                                    </div>

                                </Card>
                            )}
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

const mapStatetoProps = (state) => {
    return {
        profile: state.Auth.profile
    }
}

export default connect(
    mapStatetoProps, {}
)(withRouter(Index))
